import { useState } from 'react';

// material ui
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// components
import { PlayerAdditions } from './components/player-additions';
import { PlayerWithdrawals } from './components/player-withdrawals';

export const AuditorPlayerTransactionsPage = () => {
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <>
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleTabChange} aria-label="lab API tabs example">
            <Tab label="Cash In Transactions" value="1" />
            <Tab label="Cash Out Transactions" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" style={{ padding: '0em' }}>
          <PlayerAdditions />
        </TabPanel>
        <TabPanel value="2" style={{ padding: '0em' }}>
          <PlayerWithdrawals />
        </TabPanel>
      </TabContext>
    </>
  );
};
